import { motion } from "framer-motion";
import { OBJECTIONS } from "../data";
import { ShieldCheck, GraduationCap, Wallet, MessageCircle } from "lucide-react";
import { WhatsAppButton } from "./WhatsAppButton";

const icons = { ShieldCheck, GraduationCap, Wallet, MessageCircle };

export const Objections = () => (
  <section id="einwaende" className="relative mx-auto max-w-6xl scroll-mt-24 px-4 py-16 sm:px-6 sm:py-24">
    <div className="aurora right-[10%] top-[10%] h-72 w-72 bg-[#3B82F6] opacity-20" />
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="relative mb-12 text-center"
    >
      <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#60A5FA] sm:text-sm">Ehrliche Antworten</span>
      <h2 className="mt-3 font-heading text-2xl font-extrabold tracking-tight text-white sm:text-3xl md:text-4xl">
        Deine wichtigsten Fragen – <span className="gradient-text">klar beantwortet</span>
      </h2>
    </motion.div>

    <div className="relative grid grid-cols-1 gap-4 sm:grid-cols-2">
      {OBJECTIONS.map((o, i) => {
        const Icon = icons[o.icon];
        return (
          <motion.div
            key={i}
            data-testid={`objection-${i}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: (i % 2) * 0.1 }}
            className="flex gap-4 rounded-2xl border border-white/10 bg-[#0D131F] p-6 transition-colors hover:border-[#3B82F6]/40"
          >
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-[#1E90FF] to-[#60A5FA] text-[#05070D]">
              <Icon className="h-5 w-5" />
            </div>
            <div>
              <h3 className="font-heading text-lg font-bold text-white">{o.q}</h3>
              <p className="mt-2 text-sm leading-relaxed text-gray-400">{o.a}</p>
            </div>
          </motion.div>
        );
      })}
    </div>

    <div className="mt-10 flex justify-center">
      <WhatsAppButton size="lg" testid="objections-whatsapp" label="Noch Fragen? Frag uns auf WhatsApp" pulse />
    </div>
  </section>
);
